<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>M9预售补发</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="订单号" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.order_id"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.mail"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box" v-if="roleCheck('105-106-101-102')">
                <div class="button white" :class="{ disabled: selectedIds.length === 0 }" @click="preview">
                    <span>预演({{ selectedIds.length }})</span>
                </div>
                <div class="button" :class="{ disabled: selectedIds.length === 0 }" @click="confirmBackfill">
                    <span>确认补发({{ selectedIds.length }})</span>
                </div>
            </div>
            <el-table
                ref="backfillTable"
                highlight-current-row
                :data="listData"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column type="selection" width="45" :selectable="canSelect"></el-table-column>
                <el-table-column prop="id" label="ID" width="70"></el-table-column>
                <el-table-column prop="order_id" label="订单号" min-width="140"></el-table-column>
                <el-table-column prop="mail" label="邮箱" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        <span class="pending" v-if="scope.row.status === 1">待处理</span>
                        <span class="done" v-else>已补发</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" min-width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.created_at || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" min-width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.updated_at || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>

        <!-- 结果弹窗：预演 / 补发结果 -->
        <Gh-Dialog ref="resultDialog" size="big" :title="resultTitle">
            <template v-slot:content>
                <div class="stat_box">
                    <div class="stat_item"><p class="stat_num">{{ result.total }}</p><p class="stat_label">总数</p></div>
                    <div class="stat_item"><p class="stat_num blue">{{ result.issued }}</p><p class="stat_label">发码</p></div>
                    <div class="stat_item"><p class="stat_num blue">{{ result.emailed }}</p><p class="stat_label">发邮件</p></div>
                    <div class="stat_item"><p class="stat_num red">{{ result.missing }}</p><p class="stat_label">查不到订单</p></div>
                    <div class="stat_item"><p class="stat_num yellow">{{ result.skipped }}</p><p class="stat_label">跳过</p></div>
                </div>
                <el-table :data="result.detail" style="width: 100%" max-height="420">
                    <el-table-column prop="fail_id" label="记录ID" width="80"></el-table-column>
                    <el-table-column prop="order_id" label="订单号" min-width="140"></el-table-column>
                    <el-table-column prop="mail" label="邮箱" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="canonical" label="用户标识" min-width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column label="动作" width="110">
                        <template slot-scope="scope">
                            <span :class="actionClass(scope.row.action)">{{ actionMap[scope.row.action] || scope.row.action || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="error" label="说明" min-width="160" show-overflow-tooltip></el-table-column>
                </el-table>
            </template>
            <template v-slot:cancel_btn></template>
            <template v-slot:confirm_btn>
                <div class="button" @click="$refs.resultDialog.show = false">
                    <span>关闭</span>
                </div>
            </template>
        </Gh-Dialog>
    </div>
</template>
<script>
export default({
    name: 'm9-presale-backfill',
    data() {
        return {
            searchData: {
                order_id: '',
                mail: '',
                page: 1,
                page_size: 10
            },
            listData: [],
            total: 0,
            selectedIds: [],       // 勾选的 order_id 列表
            submitting: false,     // 防连点
            result: {
                total: 0,
                issued: 0,
                emailed: 0,
                missing: 0,
                skipped: 0,
                detail: []
            },
            resultTitle: '补发结果',
            actionMap: {
                issued: '发码',
                skipped: '已有码跳过',
                missing: '查不到订单',
                error: '异常'
            }
        }
    },
    activated() {
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getList() {
            this.api.getM9PresaleFailList(this.searchData).then(res => {
                // 列表接口成功码为 200
                if (res.code === 200) {
                    this.listData = res.data.list || [];
                    this.total = res.data.total || 0;
                }
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        handleSelectionChange(rows) {
            this.selectedIds = rows.map(r => r.order_id).filter(Boolean);
        },
        // 仅「待处理」记录可勾选补发
        canSelect(row) {
            return row.status === 1;
        },
        preview() {
            if (this.selectedIds.length === 0) {
                this.$message('请先勾选需要补发的记录');
                return;
            }
            this.doBackfill(true);
        },
        confirmBackfill() {
            if (this.selectedIds.length === 0) {
                this.$message('请先勾选需要补发的记录');
                return;
            }
            this.$confirm(`确认对选中的 ${this.selectedIds.length} 条记录执行真实补发？该操作会真实发放兑换码并发送邮件，且不可撤销。`, '补发确认', {
                confirmButtonText: '确认补发',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.doBackfill(false);
            }).catch(() => {});
        },
        doBackfill(dryRun) {
            if (this.submitting) return;
            this.submitting = true;
            // 兜底：http 封装在业务失败/网络错误时 Promise 不落定，超时后自动解锁，避免按钮永久禁用
            const submitTimer = setTimeout(() => {
                this.submitting = false;
            }, 30000);
            this.api.m9PresaleBackfill({
                dry_run: dryRun,
                order_ids: this.selectedIds
            }).then(res => {
                clearTimeout(submitTimer);
                this.submitting = false;
                // 补发接口成功码为 0
                if (res.code === 0) {
                    this.showResult(res.data, dryRun);
                    if (!dryRun) {
                        this.$message.success('补发执行完成');
                        this.getList();
                        this.$refs.backfillTable.clearSelection();
                        this.selectedIds = [];
                    }
                }
            })
        },
        showResult(data, dryRun) {
            this.result = Object.assign({
                dry_run: dryRun,
                total: 0,
                issued: 0,
                emailed: 0,
                missing: 0,
                skipped: 0,
                detail: []
            }, data || {});
            this.resultTitle = dryRun ? '补发预演结果' : '补发结果';
            this.$refs.resultDialog.show = true;
        },
        actionClass(action) {
            switch(action) {
                case 'issued': return 'a-issued';
                case 'skipped': return 'a-skipped';
                case 'missing': return 'a-missing';
                case 'error': return 'a-error';
                default: return '';
            }
        }
    }
})
</script>
<style lang="less" scoped>
    .btn_box{
        display: flex;
        align-items: center;
        padding: 0 0 12px;
        .button.disabled{
            opacity: 0.5;
            pointer-events: none;
        }
    }
    .pending{
        color: #F8AF0C;
    }
    .done{
        color: #00D6B9;
    }
    .stat_box{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 16px 20px;
        margin-bottom: 16px;
        background: #f7f9fc;
        border-radius: 8px;
        .stat_item{
            min-width: 80px;
            text-align: center;
            .stat_num{
                font-size: 24px;
                font-weight: 600;
                color: #303133;
                line-height: 1.2;
            }
            .stat_label{
                font-size: 12px;
                color: #909399;
                margin-top: 4px;
            }
            .stat_num.blue{ color: #2A79FF; }
            .stat_num.red{ color: #F56C6C; }
            .stat_num.yellow{ color: #F8AF0C; }
        }
    }
    .a-issued{ color: #00D6B9; }
    .a-skipped{ color: #F8AF0C; }
    .a-missing{ color: #F56C6C; }
    .a-error{ color: #F56C6C; }
</style>


// WEBPACK FOOTER //
// src/view/product/m9/presale-backfill.vue